/* eslint-disable */
import { previousUploadActionTypes } from "../actions/actionTypes";

let initialState = {};
const previousUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case previousUploadActionTypes.GET_PREVIOUS_UPLOAD:
      return state;
    case previousUploadActionTypes.GET_PREVIOUS_UPLOAD_SUCCEEDED:
      return action.payload;
    case previousUploadActionTypes.GET_PREVIOUS_UPLOAD_FAILED:
      return action.payload;
    case previousUploadActionTypes.GET_PREVIOUS_UPLOAD_RESET:
      return initialState;
    default:
      return state;
  }
};
export default previousUploadReducer;
